<template>
  <div class="clientFundDetailWriteOff">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="custom-field">
        <div class="custom-field-label">{{ $t.clientFund.customerName }}</div>
        <div class="custom-field-value">
          <span>{{ CustomerName }}</span>
        </div>
      </div>

      <van-field
        v-model="form.BookkeepingSCIdSn"
        :label="$t.clientFund.writeOff1"
        @click="pickerShow('showCurrencyPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <div class="custom-field">
        <div class="custom-field-label">{{ $t.clientFund.beforeBlance }}</div>
        <div class="custom-field-value">
          <span>{{ numFormat(CustomerAfterBlance) }}</span>
        </div>
      </div>

      <van-field
        v-model="form.BookkeepingAmount"
        :label="$t.clientFund.writeOff2"
        label-class="number-label"
        @blur="writeOffChange"
        :placeholder="$t.meta.input"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :rules="formRule"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            native-type="button"
            @click="getAllBalance"
            >{{ $t.clientFund.all }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.Remark"
        :label="$t.clientFund.writeOff3"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
        type="textarea"
        rows="3"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm($event)"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Popup, Picker } from "vant";

Vue.use(Form).use(Field).use(Button).use(Popup).use(Picker);

export default {
  name: "clientFundDetailWriteOff",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      CustomerName: "",
      CustomerBlance: 0.0,
      CustomerAfterBlance: 0.0,
      form: {
        CustomerId: null,
        BookkeepingSCIdSn: "",
        BookkeepingSCId: null,
        BookkeepingAmount: null,
        Remark: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      //选项
      currencyList: [],
      showCurrencyPicker: false,
    };
  },
  created() {
    const { CustomerId, CustomerName } = this.$route.query;
    if (CustomerId) {
      this.CustomerName = CustomerName;
      this.form.CustomerId = CustomerId;
      this.getCurrencyList();
    }
  },
  methods: {
    writeOffChange() {
      if (this.form.BookkeepingAmount > this.CustomerBlance) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.clientFund.excess,
          type: "error",
        });
        return;
      }
      this.CustomerAfterBlance = this.CustomerBlance;

      if (this.form.BookkeepingAmount > 0 && this.form.BookkeepingSCId) {
        this.CustomerAfterBlance = this.CustomerAfterBlance - this.form.BookkeepingAmount;
      }
    },
    getAllBalance() {
      this.form.BookkeepingAmount = this.CustomerBlance;
      this.CustomerAfterBlance = 0.0;
    },
    getWriteOffBalance(id) {
      if (id) {
        for (var cy of this.currencyList) {
          if (cy.value == id) {
            this.CustomerBlance = cy.AmountBalance;
            this.CustomerAfterBlance = cy.AmountBalance;
            break;
          }
        }
        this.form.BookkeepingAmount = null;
      } else {
        this.CustomerBlance = 0.0;
        this.CustomerAfterBlance = 0.0;
      }
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        var param = {
          CustomerId: this.form.CustomerId,
        };
        this.$api.financialManagement
          .getCustomerAvailableFundListByCustomerId(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn + " ( " + item.AmountBalance + " ) ",
                value: item.SCId,
                AmountBalance: item.AmountBalance,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    currencyConfirm(e) {
      this.form.BookkeepingSCIdSn = e.text;
      this.form.BookkeepingSCId = e.value;
      this.showCurrencyPicker = false;
      this.getWriteOffBalance(e.value);
    },
    onSubmit() {
      var param = {};
      param = this.form;
      this.$commonMethod.showLoading();
      this.$api.financialManagement
        .customerFundWriteOff(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    numFormat(num) {
      num = num.toFixed(2);
      var result = num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
          return $1 + ",";
        });
      });
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.clientFundDetailWriteOff {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #999;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      color: #323233;
    }
  }
  .custom-field-symbol {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    padding: 10px;
    .symbol {
      display: inline-block;
    }
  }
}
</style>
